import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AuthEffects } from './auth.effects';
import * as fromAuth from './auth.reducer';
import * as fromAuthState from './state';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromAuthState.authFeatureKey, fromAuth.reducer),
    EffectsModule.forFeature([AuthEffects])
  ],
  declarations: []
})
export class AuthStateModule {}
